export type AccountingClassStatus =
  | "pending"
  | "verified"
  | "inactive"
  | "verifying";

export class AccountingClass {
  id = -1;
  name: "";
  archived: boolean;
  inactive: boolean;
  qbo_status: AccountingClassStatus;
  usages: AccountingClassUsages;
  links: {
    archive?: string; // PUT
    unarchive?: string; // PUT
  };

  get usageCount() {
    return Object.values(this.usages).reduce((acc, count) => acc + count);
  }

  get hasUsages() {
    return this.usageCount > 0;
  }

  constructor(params: Partial<AccountingClass> = {}) {
    Object.assign(this, params);
  }
}

export class DepartmentChangePreview {
  invoice: InvoiceDepartmentChangePreview;

  constructor(params: Partial<DepartmentChangePreview> = {}) {
    Object.assign(this, params);
  }
}

export class InvoiceDepartmentChangePreview {
  changes_present: boolean;
  current_accounting_class: AccountingClass;
  new_accounting_class: AccountingClass;
  accounting_class_changed: boolean;

  line_items: Array<LineItemDepartmentChangePreview>;

  constructor(params: Partial<InvoiceDepartmentChangePreview> = {}) {
    Object.assign(this, params);
  }
}

export class LineItemDepartmentChangePreview {
  id: bigint;
  unit_name: string;
  current_accounting_class: AccountingClass;
  new_accounting_class: AccountingClass;
  accounting_class_changed: boolean;

  constructor(params: Partial<LineItemDepartmentChangePreview> = {}) {
    Object.assign(this, params);
  }
}

export class AccountingClassUsages {
  departments: 0;
  tasks: 0;
  discounts: 0;
  warranty_programs: 0;
  membership_programs: 0;
  invoices: 0;
  line_items: 0;
}
